import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@shared/utils'

/**
 * Vỏ chung của mọi ô nhập (Input, Textarea, SelectTrigger): nền `bg-background` (trang có nền xám xanh – ô trong suốt lệch màu với ô ngày / nút viền; customer/web cùng bản từ 15/10/2026), góc `rounded-lg`, viền, focus ring,
 * trạng thái lỗi / khóa. Đổi ở đây là đổi cho cả bộ — đừng để từng ô tự chọn nền / góc (nợ 01/10: Textarea trắng, góc nhỏ hơn).
 * Tailwind 3 không có `ring-3` → dùng `ring-[3px]` (trước đây focus ring không hiện).
 */
export const fieldSurface =
  'rounded-lg border border-input bg-background text-sm outline-none transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:focus-visible:border-destructive aria-invalid:focus-visible:ring-destructive/30 dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 disabled:cursor-not-allowed disabled:bg-muted disabled:text-foreground/80 dark:disabled:bg-input/80'

/** Phần vỏ cho ô chọn dựng trên `Button variant="outline"` (DatePicker, Combobox): cùng nền / góc / focus với ô nhập */
export const fieldTriggerSurface =
  'rounded-lg border-input bg-background text-sm dark:bg-input/30 focus-visible:ring-offset-0 focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:focus-visible:border-destructive aria-invalid:focus-visible:ring-destructive/30 ' +
  // khóa: giống hệt ô gõ chữ bị khóa (fieldSurface) – nền muted, chữ đọc được; đè `disabled:opacity-50` của Button
  'disabled:cursor-not-allowed disabled:opacity-100 disabled:bg-muted disabled:text-foreground/80 dark:disabled:bg-input/80 disabled:[&_svg]:opacity-40'

export const ShadcnInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        fieldSurface,
        'h-8 w-full min-w-0 px-2 py-1 file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground disabled:pointer-events-none',
        className,
      )}
      {...props}
    />
  ),
)
ShadcnInput.displayName = 'ShadcnInput'

export { ShadcnInput as Input }
